// localStorage wrappers — free tier storage
const KEYS = {
  business: 'inv_business',
  customers: 'inv_customers',
  items: 'inv_items',
  history: 'inv_history',
  counter: 'inv_counter',
  last_invoice: 'inv_last_draft',
};

const safeParse = (raw, fallback) => {
  if (!raw) return fallback;
  try { return JSON.parse(raw); } catch { return fallback; }
};

export const local = {
  getBusiness: () => safeParse(localStorage.getItem(KEYS.business), null),
  setBusiness: (b) => localStorage.setItem(KEYS.business, JSON.stringify(b)),

  getCustomers: () => safeParse(localStorage.getItem(KEYS.customers), []),
  addCustomer: (c) => {
    const list = local.getCustomers();
    const gstin = String(c.gstin || '').trim().toUpperCase();
    const name = String(c.name || '').trim().toLowerCase();
    const existing = list.find((x) => {
      const xGstin = String(x.gstin || '').trim().toUpperCase();
      if (gstin && xGstin) return xGstin === gstin;
      return !gstin && String(x.name || '').trim().toLowerCase() === name;
    });
    const filtered = list.filter((x) => x.id !== existing?.id);
    const next = [{ ...(existing || {}), ...c, id: existing?.id || c.id || crypto.randomUUID(), gstin }, ...filtered].slice(0, 10);
    localStorage.setItem(KEYS.customers, JSON.stringify(next));
    return next;
  },
  setCustomers: (arr) => localStorage.setItem(KEYS.customers, JSON.stringify(arr)),
  removeCustomer: (id) => {
    const next = local.getCustomers().filter((c) => c.id !== id);
    localStorage.setItem(KEYS.customers, JSON.stringify(next));
  },

  getItems: () => safeParse(localStorage.getItem(KEYS.items), []),
  addItem: (i) => {
    const list = local.getItems();
    const filtered = list.filter((x) => x.description !== i.description);
    const next = [{ id: i.id || crypto.randomUUID(), ...i }, ...filtered].slice(0, 10);
    localStorage.setItem(KEYS.items, JSON.stringify(next));
    return next;
  },
  setItems: (arr) => localStorage.setItem(KEYS.items, JSON.stringify(arr)),
  removeItem: (id) => {
    const next = local.getItems().filter((i) => i.id !== id);
    localStorage.setItem(KEYS.items, JSON.stringify(next));
  },

  getHistory: () => safeParse(localStorage.getItem(KEYS.history), []),
  addHistory: (inv) => {
    const list = local.getHistory();
    const key = inv.bj_key || inv.full?.bj_key || inv.id || inv.number;
    const filtered = list.filter((h) => (h.bj_key || h.full?.bj_key || h.id || h.number) !== key);
    const next = [inv, ...filtered].slice(0, 5);
    localStorage.setItem(KEYS.history, JSON.stringify(next));
    return next;
  },
  clearHistory: () => localStorage.removeItem(KEYS.history),
  removeHistory: (idOrNumber) => {
    const next = local.getHistory().filter((h) => h.id !== idOrNumber && h.number !== idOrNumber && h.full?.id !== idOrNumber);
    localStorage.setItem(KEYS.history, JSON.stringify(next));
    return next;
  },

  getCounter: () => {
    const raw = localStorage.getItem(KEYS.counter);
    return raw ? parseInt(raw, 10) : 1;
  },
  setCounter: (n) => localStorage.setItem(KEYS.counter, String(n)),
  nextInvoiceNumber: () => {
    const n = local.getCounter();
    return `INV-${String(n).padStart(3, '0')}`;
  },
  incrementCounter: () => {
    const n = local.getCounter() + 1;
    local.setCounter(n);
    return n;
  },

  getDraft: () => safeParse(localStorage.getItem(KEYS.last_invoice), null),
  setDraft: (d) => localStorage.setItem(KEYS.last_invoice, JSON.stringify(d)),
  clearDraft: () => localStorage.removeItem(KEYS.last_invoice),

  clearAll: () => {
    Object.values(KEYS).forEach((k) => localStorage.removeItem(k));
  },
};
